export default {
    loading: 'loading',
    processing: 'processing',
    scheduled: 'scheduled',
    done: 'done',
    error: 'error'
};
